const useGEData = {
  level1: {
    useGE: ["GE2558-ปวช.", "GE2568-ปวช."],
  },
  level2: {
    useGE: ["GE2558-ปวส.", "GE2565-ปวส.", "GE2565-ปวส.(ใหม่)", "GE2567-ปวส."],
  },
  level3: {
    useGE: [
      "GE2558-ค.อ.บ.",
      "GE2558-อส.บ.",
      "GE2558-ศศ.บ.",
      "GE2565-ค.อ.บ.",
      "GE2565-อส.บ.",
      "GE2565-ศศ.บ.",
      "GE2566-ค.อ.บ.",
      "GE2566-อส.บ.-ศศ.บ.",
      "GE2568-อส.บ.(CWIE)",
    ],
  },
  level4: { useGE: ["GE2558-ป.โท", "GE2567-ป.โท"] },
  level5: { useGE: ["GE2568-ป.บัณฑิต"] },
};

export default useGEData;
